// @core/api/endpoints/task/delete_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Delete task
 * Permanently deletes a task and all its associated data including checklists, time entries, and activity history. Requires admin privileges.
 */
export async function DeleteTask(
  task_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
